/**
 * Contact page scripts.
 *
 * @package TZN_WP_Theme
 */

document.addEventListener('DOMContentLoaded', () => {
  // Contact page loaded
});
